<template>
    <div class="row">

      <notifications group="foo" position="top right" />

        <div class="col-lg-8 col-lg-offset-2 col-xs-12 content">
            <CreditInfo />
        </div>

        <div class="col-lg-2 col-lg-offset-2 col-xs-12 block content">
            <UserMenu />
        </div>

        <div class="col-lg-6 col-xs-12 block content">
            <div class="spinner" v-if="loading">
                <div class="double-bounce1"></div>
                <div class="double-bounce2"></div>
            </div>
            <div class="setting" v-if="!loading">
                <h3> Gmail </h3>
                <a v-if="!user_data.gmail_credentials" :href="`/google/authorize?token=${user_data.access_token}${csv}`">
                  <img src="@/assets/btn_google_signin_light_normal_web@2x.png" width="200" style="cursor: pointer" />
                </a>
                <button @click="handleSignoutClick" v-if="user_data.gmail_credentials" class="btn large-btn bold">Disconnect Gmail</button>

                <!-- button @click="handleAuthClick" v-if="!auth" class="btn large-btn bold">Grant Permissions</button -->
            </div>
        </div>
    </div>
</template>

<script>

import CreditInfo from '@/components/CreditInfo.vue'
import UserMenu from '@/components/UserMenu.vue'
import { mapMutations } from 'vuex'

export default {
  name: 'developer',
  components: {
    CreditInfo,
    UserMenu
  },
  data () {
    return {
      text: 'Grant Permissions',
      csv: '',
      loading: true
    }
  },
  mounted () {
    this.$http.get('/api/user').then((res) => {
      this.setAuthUser(res.data)
      if (this.$route.query.csv && !this.user_data.gmail_credentials) {
        this.csv = `&csv=${this.$route.query.csv}`
        this.displayLog()
      }
      if (this.$route.query.csv && this.user_data.gmail_credentials) {
        this.csv = `&csv=${this.$route.query.csv}`
        this.$router.push({ name: 'csv_details', params: { id: this.$route.query.csv } })
      }
      if (this.$route.query.gmail_error) {
        this.displayError()
      }
      this.loading = false
    })
  },
  methods: {
    ...mapMutations('user', [
      'setAuthUser'
    ]),
    displayLog () {
      this.$notify({
        group: 'foo',
        type: 'error',
        text: 'Please connect your Gmail account first',
        duration: 10000
      })
    },
    displayError () {
      this.$notify({
        group: 'foo',
        type: 'error',
        text: 'Please try again',
        duration: 10000
      })
    },
    updateSigninStatus (isSignedIn) {
      this.auth = isSignedIn
      if (this.auth && this.$route.query.csv) {
        this.$router.push({ name: 'csv_details', params: { id: this.$route.query.csv } })
      }
    },
    handleSignoutClick () {
      this.$http.post('/api/user/gmail/logout').then((res) => {
        this.setAuthUser(res.data)
      }).catch((e) => {
        this.displayError()
        console.log(e)
      })
    }
  },
  computed: {
    user_data: function () {
      return this.$store.state.user.data
    }
  }
}
</script>
